module.exports = __webpack_public_path__ + "static/media/sleep.cea8c828.svg";